export async function delay(ms: number, abortController?: AbortController): Promise<void> {
  await new Promise((resolve) => {
    const id = setTimeout(resolve, ms)
    abortController?.signal.addEventListener('abort', () => {
      clearTimeout(id)
    })
  })
}
